import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { HttpClientJsonpModule } from '@angular/common/http';
import {  ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainNavigationComponent } from './components/main-navigation/main-navigation.component';
import { MapComponent } from './components/map/map.component';
import { RouteStatusComponent } from './components/route-status/route-status.component';
import { SystemStatusComponent } from './components/system-status/system-status.component';
import { RouteSelectionComponent } from './components/route-selection/route-selection.component';
import { NtaComponent } from './components/nta/nta.component';
import { TrainviewComponent } from './components/trainview/trainview.component';
import { TransitviewComponent } from './components/transitview/transitview.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { EmbeddedMapComponent } from './components/embedded-map/embedded-map.component';
import { TripDetailComponent } from './components/trip-detail/trip-detail.component';
import { EmbeddedMapDetailComponent } from './components/embedded-map-detail/embedded-map-detail.component';
import { TrainSearchComponent } from './components/train-search/train-search.component';
import { SystemWideMessageComponent } from './components/system-wide-message/system-wide-message.component';
import { OmniSearchComponent } from './components/omni-search/omni-search.component';
import { StopComponent } from './components/stop/stop.component';
import { EmbeddedMapSingleComponent } from './components/embedded-map-single/embedded-map-single.component';
import { TripSchedulesComponent } from './components/trip-schedules/trip-schedules.component';
import { EmbeddedMapTripComponent } from './components/embedded-map-trip/embedded-map-trip.component';
import { MainFooterComponent } from './components/main-footer/main-footer.component';
import { FourOhFourComponent } from './components/four-oh-four/four-oh-four.component';
import { FormsModule } from '@angular/forms';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SchedulesComponent } from './components/schedules/schedules.component';
import { ScheduleRoutesComponent } from './components/schedule-routes/schedule-routes.component';
import { ScheduleRouteDetailsComponent } from './components/schedule-route-details/schedule-route-details.component';
import { RouteStatusButtonComponent } from './components/route-status-button/route-status-button.component';
import { ScheduleTimetableComponent } from './components/schedule-timetable/schedule-timetable.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouteHeaderComponent } from './components/route-header/route-header.component';
import { RouteDirectionSelectorComponent } from './components/route-direction-selector/route-direction-selector.component';
import { ScheduleRouteTodayComponent } from './components/schedule-route-today/schedule-route-today.component';
import { StopDetailsComponent } from './components/stop-details/stop-details.component';

@NgModule({
  declarations: [
    AppComponent,
    MainNavigationComponent,
    MapComponent,
    RouteStatusComponent,
    SystemStatusComponent,
    RouteSelectionComponent,
    NtaComponent,
    TrainviewComponent,
    TransitviewComponent,
    DashboardComponent,
    EmbeddedMapComponent,
    TripDetailComponent,
    EmbeddedMapDetailComponent,
    TrainSearchComponent,
    SystemWideMessageComponent,
    OmniSearchComponent,
    StopComponent,
    EmbeddedMapSingleComponent,
    TripSchedulesComponent,
    EmbeddedMapTripComponent,
    MainFooterComponent,
    FourOhFourComponent,
    BreadcrumbComponent,
    SchedulesComponent,
    ScheduleRoutesComponent,
    ScheduleRouteDetailsComponent,
    RouteStatusButtonComponent,
    ScheduleTimetableComponent,
    RouteHeaderComponent,
    RouteDirectionSelectorComponent,
    ScheduleRouteTodayComponent,
    StopDetailsComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpClientJsonpModule,
    AppRoutingModule,
    NgbModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
